import { StringKeyDictionary } from "../commonInterfaces.js";
import { DatePicker } from "../core/components/datePicker.js";
import { Dialog, DialogAction } from "../core/components/dialog.js";
import { FieldInstance } from "../core/components/field.js";
import { Label } from "../core/components/label.js";
import { TextBox } from "../core/components/textBox.js";
import { Config } from "../core/config/config.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Helper } from "../core/util/helper.js";
import React from "react";
export default class ChangePeriodDialog extends React.Component<ChangePeriodDialogProps, ChangePeriodDialogState>
{
    private factory = ComponentHelper.createFactory();
    private actions: Array<DialogAction> = [
        {
            label: Config.translations.cancel,
            action: () => {
                this.props.onDialogCancle()
            }
        },
        {
            label: Config.translations.ok,
            action: () => {
                if (Helper.hasValue(this.props.newStart) && Helper.hasValue(this.props.newEnd))
                    this.props.onDialogOk()
                else
                    DialogHelper.alert(this.props.translations["WebCRM.Tasks.RecurringTaskHistory.MandatoryField"]);
            },
            primary: true
        }
    ]

    constructor(props: ChangePeriodDialogProps) {
        super(props)
        this.state = {
            dialogOpen: false,
        }
    }

    openDialog = () => {
        this.setState({ dialogOpen: true });
    }

    private getTextBoxProps = (value: Date, fieldModel: string) => {
        const props = this.factory.getDefaultTextBoxProps();
        let valueString = value.toString();
        valueString = kendo.toString(kendo.parseDate(valueString), "d");
        props.value = valueString;
        props.field.model = fieldModel;
        props.field.multiLine = true;
        return props;
    }

    private getTextBox = (label: string, value: Date, fieldModel: string) => {
        const props = this.getTextBoxProps(value, fieldModel);
        return <FieldInstance noHover={true} label={label}>
            <Label {...props} />
        </FieldInstance>;
    }

    private getDatePickerProps = (value: Date, fieldModel: string, onChange: (value: Date) => void) => {
        const props = this.factory.getDefaultDatePickerProps();
        props.field.clearTime = true;
        props.value = value;
        props.field.model = fieldModel;
        props.onChange = (_, value: Date) => { onChange(value) };
        return props;
    }

    private getDatePicker = (label: string, value: Date, fieldModel: string, onChange: (value: Date) => void) => {
        const datePickerProps = this.getDatePickerProps(value, fieldModel, onChange);
        return <FieldInstance noHover={true} label={label}>
            <DatePicker {...datePickerProps} />
        </FieldInstance>;
    }

    private afterClose = () => {
        this.setState({ dialogOpen: false })
    }

    private createDialog = () => {
        let dpNewStart = this.getDatePicker(this.props.translations["WebSMS.TravelReport.NewStart1"], this.props.newStart, "newStart", this.props.onStartChange);
        let dpOldEnd = this.getDatePicker(this.props.translations["WebSMS.TravelReport.NewEnd"], this.props.newEnd, "newEnd", this.props.onEndChange);

        let tbCurrentStart = this.getTextBox(this.props.translations["WebSMS.TravelReport.CurrentStart"], this.props.currentStart, "currentStart");
        let tbCurrentEnd = this.getTextBox(this.props.translations["WebSMS.TravelReport.CurrentEnd"], this.props.currentEnd, "currentEnd");

        return (
            <Dialog title={this.props.title}
                actions={this.actions}
                open={true}
                afterClose={() => { this.afterClose() }}
                width={"400px"}>
                <div>
                    { tbCurrentStart }
                    { dpNewStart }
                    { tbCurrentEnd }
                    { dpOldEnd }
                </div>
            </Dialog>);
    }

    render() {
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        return dialog;
    }
}

interface ChangePeriodDialogProps {
    title: string,
    currentStart?: Date;
    currentEnd?: Date;
    newStart?: Date;
    newEnd?: Date;
    onStartChange?: (value: Date) => void;
    onEndChange?: (value: Date) => void;
    onDialogOk: () => void
    onDialogCancle: () => void
    translations: StringKeyDictionary<string>;
}

interface ChangePeriodDialogState {
    dialogOpen: boolean
}